/* 🤖 this file was generated by svg-to-ts*/
export const iconFlashTrivie = {
  name: 'flashtrivie',
  data: `<svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.32069 20.1765V13.3935H0.841506C0.218461 13.3935 -0.202515 12.7382 0.100588 12.1975L6.29736 0.450121C6.68466 -0.319929 7.88023 -0.0414006 7.88023 0.826954V7.69187H12.1573C12.7804 7.69187 13.1845 8.33085 12.9151 8.87152L6.9204 20.537C6.51627 21.3234 5.32069 21.0449 5.32069 20.1765Z" fill="url(#paint0_linear_163_8641)"/>
  <defs>
  <linearGradient id="paint0_linear_163_8641" x1="2.02985" y1="20.3361" x2="18.632" y2="13.3115" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FF00FF"/>
  <stop offset="0.46" stop-color="#9116F9"/>
  <stop offset="1" stop-color="#3199FF"/>
  </linearGradient>
  </defs>
  </svg>`,
}
